import { createContext } from "react";

export interface VersionCheckContextType {
  status: "idle" | "checking" | "updateAvailable" | "upToDate";
  currentVersion: string;
  remoteVersion: string;
  dismiss: () => void;
  snooze: () => void;
  receiveVersion: (version: string) => void;
}

export const VersionCheckContext = createContext<VersionCheckContextType | undefined>(undefined);

